import { HttpGetOurWarehouseList, HttpGetSystemSupplierList } from '@/service/bespeak'

export default {
    data(){
        return {
            warehouseList: [],
            supplierList: [],
        }
    },
    created() {
        HttpGetOurWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`,
                    code: item.code
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
        HttpGetSystemSupplierList().then(res => {
            this.supplierList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: item.supplierName,
                    code: item.supplierCode
                }
            });
        })
    },
	computed: {
        options () {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                {
                    text: this.$t("global.common.recent_month", {
                        defaultValue: "最近一月",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 30
                        );
                        return [start, end];
                    },
                },
                {
                    text: this.$t("global.common.latest_quarter", {
                        defaultValue: "最近一季度",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 90
                        );
                        return [start, end];
                    },
                },
              ],
            };
        },
        getBillTypeList(){
            return [
                { value: 1, label: '仓储费' },
                { value: 0, label: '仓库作业费' },
                { value: 2, label: '快递费' },
            ]
        },
        //调账类型
        getAdjutmentType(){
            return [
                { value: 0, label: '调账扣减' },
                { value: 1, label: '调账返还' },
            ]
        },
        //费用类型
        getCostType(){
            return [
                { value: 1, label: '仓库作业费' },
                { value: 2, label: '配送费' },
                { value: 3, label: '增值服务费' },
                { value: 4, label: '仓储费' },
                // { value: 5, label: '包材费' },
                // { value: 6, label: '调账费' },
                { value: 7, label: "库内调账"},
				{ value: 8, label: "尾程调账"},
            ]
        },
        getOrderList(){
            return [
                { value: 200, label: 'B2C销售出库' },
                { value: 400, label: '销售退货单' },
                { value: 401, label: '销售退货单-销毁' },
                { value: 410, label: '销售退货计划单' },
                { value: 417, label: '退货处理单-销毁' },
                { value: 418, label: '退货处理单-换标' },
                { value: 430, label: '入库单' },
                { value: 431, label: '无来源入库单' },
                { value: 330, label: '调拨入库单' },
                { value: 310, label: '调拨出库单' },
                { value: 130, label: '中转入库单' },
                { value: 120, label: '中转出库单' },
                { value: 100, label: '中转入库计划' },
                { value: 6001, label: '销毁单' },
                { value: 202, label: 'B2C-卡车' },
                { value: 203, label: 'B2C-卡车PO' },
                { value: 204, label: 'B2C-快递PO' },
                { value: 299, label: '拦截单-B2C' },
                { value: 2991, label: '拦截单-B2C卡车' },
                { value: 2992, label: '拦截单-B2C卡车PO' },
                { value: 2993, label: '拦截单-B2C快递PO' },
                { value: 420, label: '入库计划单' },
                { value: 490, label: '认领处理单' },
                { value: 491, label: '认领处理单-销毁' },
            ]
        },
        getInventoryTypeList(){
            return [
                { value: 0, label: '正常库存' },
                { value: 1, label: '不可售库存' },
            ]
        },
        getChargingProjects(){
            return [
                {value: 0, label: '全选'},
                {value: 1, label: '拣货下架费'},
                {value: 2, label: '订单处理费'},
                {value: 3, label: '特殊处理费'},
                {value: 4, label: '运单处理费'},
                {value: 5, label: '销毁费'},
                {value: 6, label: '收获操作费'},
                {value: 7, label: 'PO单出库附加费'},
            ]
        },

        // 商品状态
        getOrderStatus() {
           return [{
               label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
               value: null,
           }, {
               label: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待审核' }),
               value: '5',
           }, {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
               value: '10',
           }, {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '审核拒回' }),
               value: '20',
           }, {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
               value: '30',
           }, {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已完成' }),
               value: '70',
           }, {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已取消' }),
               value: '90',
           }]
        },

        // 产品类型
        getGoodsType() {
            return [{
                label: this.$tc('fbb.sales.goods_type', 0, { defaultValue: '成品' }),
                value: '0',
            }, {
                label: this.$tc('fbb.sales.goods_type', 1, { defaultValue: '配件' }),
                value: '1',
            }, {
                label: this.$tc('fbb.sales.goods_type', 2, { defaultValue: '耗材' }),
                value: '2',
            }]
        },
    }

}
